import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/merch-ui/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/appRouter/StyledComponentsRegistry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/appRouter/ThemeProviderWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/merch-ui/src/styles/global.css");
